export default {
  symplatickets: [],
  symplaticket: {},
  ticketpagination: {},
  symplaevent: {},
  symplaevents: []
}
